var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAppleAddToLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-apple_add_to_library") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-Icons---\\u2660\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-apple_add_to_library"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,22 L36.9967222,22 C38.103102,22 39,22.8877297 39,24 C39,25.1045695 38.1021596,26 36.9967222,26 L26,26 L26,36.9967222 C26,38.103102 25.1122703,39 24,39 C22.8954305,39 22,38.1021596 22,36.9967222 L22,26 L11.0032778,26 C9.896898,26 9,25.1122703 9,24 C9,22.8954305 9.8978404,22 11.0032778,22 L22,22 L22,11.0032778 C22,9.896898 22.8877297,9 24,9 C25.1045695,9 26,9.8978404 26,11.0032778 L26,22 Z",
    id: "add",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-dummy-icon",
    stroke: "#FF6666",
    strokeDasharray: "2,3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L46,46",
    id: "Line",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L46,46",
    id: "Line",
    strokeWidth: 2,
    transform: "translate(23.000000, 23.000000) rotate(-270.000000) translate(-23.000000, -23.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppleAddToLibrary);
export default __webpack_public_path__ + "static/media/icon-apple_add_to_library.9418bf5b81299ccc4b1ac3050ff5ed39.svg";
export { ForwardRef as ReactComponent };